import React from 'react';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import IngredientsApi from '../../../../services/api/IngredientsApi';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';

import PrimaryButton from '../../../../components/common/forms/Button/PrimaryButton';
import BorderlessButton from '../../../../components/common/forms/Button/BorderlessButton';
import BaseButton from '../../../../components/common/forms/Button/BaseButton';
import SecondaryButton from '../../../../components/common/forms/Button/SecondaryButton';
import PrimaryAlternativeButton from '../../../../components/common/forms/Button/PrimaryAlternativeButton';
import TertiaryButton from '../../../../components/common/forms/Button/TertiaryButton';
import LinkButton from '../../../../components/common/forms/Button/LinkButton';

import filterIcon from '../../../../static/img/filterIcon.svg';
import createIcon from '../../../../static/img/createIcon.svg';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';
import styled from 'styled-components';

const validationSchema = yup.object().shape({
  name: yup.string().label('Name').min(2, 'Name should be at least 2 symbols').required('Name is required'),
});

export default function IngredientCreate() {
  const history = useHistory();
  const location = useLocation();

  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    const res = await IngredientsApi.createIngredient(values);
    if (res.status === StatusCodes.OK) {
      const isNutritionPath = location.pathname === '/nutrition';
      history.push(isNutritionPath ? `/nutrition/ingredient/${res.data.id}` : '/ingredients');
    } else {
      setSubmitting(false);
    }
  };

  return (
    <WhitePad>
      <TitleComponent title="Create Ingredient" onLeftHandler={history.goBack} titleLeft="Back" />
      <FormWrapper>
        <Formik
          initialValues={{
            name: '',
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => saveItem(values, setSubmitting)}
        >
          {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
            <form onSubmit={handleSubmit} autoComplete="off" style={{ width: '454px' }}>
              <FormRow>
                <TextInputComponent
                  cols={12}
                  label="Name"
                  name="name"
                  value={values.name}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </FormRow>
              <ActionWrapper>
                <PrimaryButton isSubmitting={isSubmitting} type="submit" title="Save" />
                <BorderlessButton marginLeft="30px" title="Delete" />
              </ActionWrapper>
            </form>
          )}
        </Formik>
      </FormWrapper>
      {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        BaseButton
        <BaseButton title="BaseButton" />
        PrimaryButton
        <PrimaryButton title="PrimaryButton" />
        PrimaryAlternativeButton
        <PrimaryAlternativeButton title="PrimaryAlternativeButton" />
        SecondaryButton
        <SecondaryButton title="SecondaryButton" />
        TertiaryButton
        <TertiaryButton title="TertiaryButton" />
        LinkButton
        <LinkButton title="LinkButton" />
        BorderlessButton
        <BorderlessButton title="BorderlessButton" icon={filterIcon} />
        BorderlessButton vertical
        <BorderlessButton title="BorderlessButton" icon={filterIcon} vertical={true} />
        BorderlessButton icon only
        <BorderlessButton icon={createIcon} />
      </div> */}
    </WhitePad>
  );
}

const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
`;
